module.exports = __webpack_public_path__ + "img/wallet_details.c25c1f33.svg";